// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginForm_container__IXOmq","root":"LoginForm_root__ci2qs","button":"LoginForm_button__VdINR"};